<template>
  <div class="banner-brow" ref="observerElement">
    <BannerList v-for="(layoutItem, index) in columnLayoutList" :key="index" :bannerList="layoutItem.bannerlist"
      :columnType="layoutItem.columnType" />
  </div>
</template>
<script setup lang="ts">
import { onBeforeMount, onMounted, ref, Ref } from 'vue';
import { useConfigStore } from '@/store';
import BannerList from '@/components/common/banner-list.vue';
import { ColumnLayout, ColumnType } from '@/types/banner-layout';
import { useStayTimebrow } from '@/components/area/mainland/recommend/hooks/use-staytime';
import { biBrow } from '@tencent/fit-bi-sdk';

const { getFilteredLayout } = useConfigStore();
// banner 列表
const columnLayoutList: Ref<ColumnLayout[] | null> = ref(null);

onBeforeMount(async () => {
  const bannerConfig = await getFilteredLayout([ColumnType.a, ColumnType.b, ColumnType.c]);
  if (bannerConfig) {
    columnLayoutList.value = bannerConfig;
  }
});
const observerElement: Ref<HTMLDivElement | null> = ref(null);
const biBrowAction = (timeInView: number) => {
  if (timeInView > 0) {
    biBrow('hot-merchant.staytime_brow', {
      fstaytime: timeInView,
    });
  }
};
useStayTimebrow(observerElement, biBrowAction);

onMounted(() => {
  if (observerElement.value) {
  }
});

</script>

<style lang="less" scoped>
@import (reference) '~@/less/main.less';
</style>
